export default "__VITE_ASSET__KFnMIPX$__"